export const devextremeLicenseKey =
	'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImNhMzIxZDcyLWYyODgtNDAxMy05NTIxLTYzNzliNzlmNGY5NCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.It4hD8oRQxukL/8QQiM1bRnqZlRV2FZdaFxQMtltGYO8hJO0m5ZcnDYkYL1V0uj3U8PygaJE5vLjNpqy5D6pDJszdq8RiByjORcE66Y38mT0xySFA2CXHsagLf7ma8b2jr30Lw==';
